import { render, staticRenderFns } from "./SetUpTab.vue?vue&type=template&id=c9938094&scoped=true&"
import script from "./SetUpTab.vue?vue&type=script&lang=js&"
export * from "./SetUpTab.vue?vue&type=script&lang=js&"
import style0 from "./SetUpTab.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SetUpTab.vue?vue&type=style&index=1&id=c9938094&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9938094",
  null
  
)

export default component.exports